import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

class KeywordsRules extends Component {
	
	render() {

		const style = {
			margin: {
				marginTop: "20px"
			}
		};

		return (
			<section>
				<div>
					<div className='container'>
						<Typography variant="headline" style={{ fontSize: "35px" }}>
							Keywords Rules
						</Typography>
						<Typography style={style.margin} component="p">
                        This section is letting you select <br />
                        the keywords that most applies to you.<br /><br />
                        We present you 4 selections of 16 keywords,<br />
                        and your goal is to select 7 out of each 16 keywords.
							
						</Typography>

						<Link to={'/quiz'} >
							<Button variant="raised" style={style.margin} color="primary">
								Start Keywords
							</Button>
						</Link>
					</div>
				</div>
			</section>
		);
	}
}

export default KeywordsRules;


// WEBPACK FOOTER //
// ./src/views/KeywordsRulesView.jsx